import React, { useContext, useEffect } from "react";
import Button from "@mui/material/Button";
import { NavHashLink as NavLink } from "react-router-hash-link";
import { makeStyles } from "@mui/styles";
import "./Landing.css";
import { ThemeContext } from "../../contexts/ThemeContext";
import { headerData } from "../../data/headerData";
import { socialsData } from "../../data/socialsData";
import { FaInstagram, FaLinkedin, FaGithub } from "react-icons/fa";
import { SiLeetcode, SiMedium } from "react-icons/si"
import Typist from "react-typist";
import gif from "../../assets/giphy.gif";
import { StarField } from "starfield-react";

function Landing() {
  const { theme, drawerOpen } = useContext(ThemeContext);
  console.log(theme.primary);
  const useStyles = makeStyles((t) => ({
    resumeBtn: {
      color: `${theme.primary} !important`,
      borderRadius: "30px !important",
      textTransform: "inherit",
      textDecoration: "none",
      width: "150px",
      fontSize: "1rem",
      fontWeight: "500",
      height: "50px",
      fontFamily: "var(--primaryFont)",
      border: `3px solid ${theme.primary} !important`,
      transition: "100ms ease-out",
      "&:hover": {
        backgroundColor: theme.tertiary,
        color: theme.secondary,
        border: `3px solid ${theme.tertiary}`,
      },
      // [t.breakpoints.down('sm')]: {
      //     width: '180px',
      // },
    },
    contactBtn: {
      backgroundColor: `${theme.primary} !important`,
      color: `${theme.secondary} !important`,
      borderRadius: "30px !important",
      textTransform: "inherit",
      textDecoration: "none",
      width: "150px",
      height: "50px",
      fontSize: "1rem",
      fontWeight: "500",
      fontFamily: "var(--primaryFont)",
      border: `3px solid ${theme.primary}`,
      transition: "100ms ease-out",
      "&:hover": {
        backgroundColor: theme.secondary,
        color: theme.tertiary,
        border: `3px solid ${theme.tertiary}`,
      },
      // [t.breakpoints.down('sm')]: {
      //     display: 'none',
      // },
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    const img = document.querySelector(".landing--img");
    
    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const distanceFromTop = img.offsetTop - scrollTop;

      if (distanceFromTop <= 0 && window.innerWidth >= 900) {
        img.style.position = "fixed";
        img.style.top = "10px";
        img.style.left = "10px";
        img.style.transform = "none";
        img.style.width = "150px";
        img.style.height = "150px";
      } else if (window.innerWidth >= 900){
        img.style.position = "absolute";
        img.style.top = "unset";
        img.style.left = "35%";
        img.style.transform = "translateX(-50%)";
        img.style.width = "400px";
        img.style.height = "400px";
      }
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="landing">
      <div className="landing--container">
        <StarField
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: "3",
            // opacity: '0.9'
          }}
          noBackground
          speed={0.5}
          starSize={0.5}
          starShape='round'
          starRatio={110}
          fps={100}
        />
        <div
          className="landing--container-left"
          style={{ backgroundColor: theme.primary }}
        >
          <div className="lcl--content anime">
            {socialsData.linkedIn && (
              <a href={socialsData.linkedIn} target="_blank" rel="noreferrer">
                <FaLinkedin
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="LinkedIn"
                />
              </a>
            )}
            {socialsData.github && (
              <a href={socialsData.github} target="_blank" rel="noreferrer">
                <FaGithub
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="GitHub"
                />
              </a>
            )}
            {socialsData.instagram && (
              <a href={socialsData.instagram} target="_blank" rel="noreferrer">
                <FaInstagram
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="Instagram"
                />
              </a>
            )}
            {socialsData.leetCode && (
              <a href={socialsData.leetCode} target="_blank" rel="noreferrer">
                <SiLeetcode
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="Instagram"
                />
              </a>
            )}
            {socialsData.medium && (
              <a href={socialsData.medium} target="_blank" rel="noreferrer">
                <SiMedium
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="Instagram"
                />
              </a>
            )}
          </div>
        </div>
        <img
          src={headerData.image}
          alt=""
          className="landing--img"
          style={{
            opacity: `${drawerOpen ? "0" : "1"}`,
            borderColor: theme.secondary,
          }}
        />
        <img src={gif} className="landing--gif" alt='gif-behind-profile' />
        <div
          className="landing--container-right"
          style={{ backgroundColor: theme.secondary }}
        >
          <div className="lcr--content" style={{ color: theme.tertiary }}>
            <h6>{headerData.title}</h6>
            <h1>{headerData.name}</h1>
            <Typist cursor={{ show: false }}>
              <p>{headerData.desciption}</p>
            </Typist>
            <div className="lcr-buttonContainer">
              {headerData.resumePdf && (
                <a
                  href={headerData.resumePdf}
                  download="resume"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button className={classes.resumeBtn}>Download CV</Button>
                </a>
              )}
              <NavLink to="/#contacts" smooth={true} spy="true" duration={2000}>
                <Button className={`${classes.contactBtn} contact-btn`}>
                  Contact
                </Button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
